// import React, { useState, useEffect } from "react";
// import "./style/floor.css";

// function Floors({ onFloorSelect, variant = "default", floorsData = [] }) {
//   // 1. تحديد الحالة الابتدائية بناءً على أول عنصر في البيانات القادمة
//   const [activeFloor, setActiveFloor] = useState("");

//   // 2. تحديث الـ activeFloor بمجرد وصول البيانات
//   useEffect(() => {
//     if (floorsData && floorsData.length > 0) {
//       // نختار اسم أول دور كافتراضي إذا لم يكن هناك دور مختار
//       setActiveFloor(prev => prev || floorsData[0].name);
//     }
//   }, [floorsData]);

//   const handleFloorClick = (floorName) => {
//     setActiveFloor(floorName);      // تحديث الحالة المحلية للـ UI (اللون النشط)
//     onFloorSelect(floorName);       // تمرير الاسم للأب (Tour.jsx) عشان يغير الصورة
//   };

//   // لو مفيش بيانات لسه، مفيش داعي نعرض حاجة أو ممكن نعرض Loading
//   if (!floorsData || floorsData.length === 0) return null;

//   return (
//     <div className={`floors floors--${variant}`}>
//       <p className="m-0 p-0 title">Floors</p>

//       {floorsData.map((floor, index) => (
//         <div
//           key={floor.id || index} // يفضل استخدام id الـ API لو متاح
//           className={`num-floor ${activeFloor === floor.name ? "active" : ""}`}
//           onClick={() => handleFloorClick(floor.name)}
//         >
//           {/* هنا هيظهر الاسم اللي راجع من الـ API (سواء F1 أو 1 أو غيره) */}
//           <p className="m-0 p-0">{floor.name}</p>
//         </div>
//       ))}
//     </div>
//   );
// }

// export default Floors;
import React from "react";
import "./style/floor.css";

// ضيفي currentFloor هنا كـ Prop
function Floors({ onFloorSelect, variant = "default", floorsData = [], currentFloor }) {
  
  const handleFloorClick = (floorName) => {
    onFloorSelect(floorName); // بنكلم الأب وهو اللي يغير الحالة
  };

  if (!floorsData || floorsData.length === 0) return null;

  return (
    <div className={`floors floors--${variant}`}>
      <p className="m-0 p-0 title">Floors</p>

      {floorsData.map((floor, index) => (
        <div
          key={floor.id || index}
          // هنا بنقارن بالـ currentFloor اللي جاية من الأب مباشرة
          className={`num-floor ${currentFloor === floor.name ? "active" : ""}`}
          onClick={() => handleFloorClick(floor.name)}
        >
          <p className="m-0 p-0">{floor.name}</p>
        </div>
      ))}
    </div>
  );
}

export default Floors;
// import React, { useState } from "react";
// import "./style/floor.css";

// function Floors({ onFloorSelect, variant = "default" }) {
//   const floors = ["Gf", "1F", "RF"];
//   const [activeFloor, setActiveFloor] = useState(floors[0]); // افتراضي Gf

//   const handleFloorClick = (floor) => {
//     setActiveFloor(floor);        // تحديث الـ active
//     onFloorSelect(floor);         // تمرير للـ parent
//   };

//   return (
//     <div className={`floors floors--${variant}`}>
//       <p className="m-0 p-0 title">Floors</p>

//       {floors.map((floor, index) => (
//         <div
//           key={index}
//           className={`num-floor ${activeFloor === floor ? "active" : ""}`}
//           onClick={() => handleFloorClick(floor)}
//         >
//           <p className="m-0 p-0">{floor}</p>
//         </div>
//       ))}
//     </div>
//   );
// }

// export default Floors;
